export default __webpack_public_path__ + "static/media/about5.07798086.jpg";